import React from "react";
import "./style.css";

const SingleTooth = ({
  item,
  onClick,
  isToothStageMatched = false,
  isSelected = false,
  isFromAdults = false,
}) => {
  const style = {
    color: isSelected && !isToothStageMatched ? "#FFFFFF" : isToothStageMatched ? "black" : "black",
  };
  return (
    <div className="single_tooth_container" onClick={onClick}>
      <div
        className="single_tooth_body"
        style={{ height: isFromAdults ? 100 : 120 }}
      >
        <div
          className="single_tooth_info"
          style={{
            background: isSelected && !isToothStageMatched
              ? "#20C3FF"
              : isToothStageMatched
              ? "#E4FFE5"
              : "",
            border: isSelected && isToothStageMatched ? "2px solid #20C3FF" : "",
          }}
        >
          <p style={style}>
            {item?.tooth_number
              ? item?.tooth_number
              : item?.tooth_identifier
              ? item?.tooth_identifier
              : item.iso}
          </p>
          <span style={style}>{item.name ? item.name : item.title}</span>
        </div>
      </div>
    </div>
  );
};

export default SingleTooth;
